import { LabelChip } from "@carbon6/c6-frontend-design";
import type { StatusTokens } from "@carbon6/c6-frontend-design";
import type { ReactNode } from "react";
import type { TrainingGpuQuotaRequestStatus } from "@/api/trainingGpuQuotaRequest";
import { statusChipColor, useStatusTokens } from "@/components/status/statusTokens";
import { quotaRequestStatusLabel } from "./gpuQuotaFormat";

// 요청 상태를 c6 status 코어 어휘에 연결하는 유일한 표. 한도 요청은 장치도 작업도 아니다. 그래서
// 도메인 그룹(device·job)이 아니라 코어 키를 직접 쓴다.
//
// - 대기: admin 의 처리가 필요하다(attention).
// - 승인됨: 증액이 반영됐다(success). 증액 기간이 끝난 뒤에도 이 상태로 남는다.
// - 거절됨: 끝났지만 요청자가 다음 행동을 정해야 한다(warning).
// - 철회됨: 요청자가 스스로 거뒀다. 더 볼 것이 없다(muted).
const STATUS_TOKEN: Record<TrainingGpuQuotaRequestStatus, (status: StatusTokens) => string> = {
  pending: (status) => status.attention,
  applied: (status) => status.success,
  rejected: (status) => status.warning,
  cancelled: (status) => status.muted,
};

// 한도 요청의 상태 칩. 다른 표의 상태 칩과 같은 크기·채움을 쓴다.
export function GpuQuotaRequestStatusChip({
  status,
}: {
  status: TrainingGpuQuotaRequestStatus;
}): ReactNode {
  const statusTokens = useStatusTokens();
  return (
    <LabelChip
      color={statusChipColor(STATUS_TOKEN[status](statusTokens))}
      size="xs"
      variant="filled"
    >
      {quotaRequestStatusLabel(status)}
    </LabelChip>
  );
}
